module.exports = __webpack_public_path__ + "img/阵雨.48c36b18.png";